<template>
  <div :id="'cont_' + formProperty.nativename" class="fldAddressGmapMeshup">
    <div class="row">
      <div class="col q-pb-md">
        <q-input v-model="street" label="Straße" filled dense clearable/>
      </div>
    </div>
    <div class="row">
      <div class="col-4 q-pb-md">
        <q-input v-model="plz" label="PLZ" filled dense clearable/>
      </div>
      <div class="col-8 q-pb-md q-pl-md">
        <q-input v-model="city" label="Ort" filled dense clearable/>
      </div>
    </div>
    <div class="row">
      <div class="col-4 q-pb-md">
        <div class="row">
          <div class="col-8">
            <q-input v-model="tolerance" type="number" suffix="m" label="Toleranz" filled dense clearable class="q-pr-sm" :readonly="lat==='' || lat == null"/>
          </div>
          <div class="col-4">
            <q-btn-group spread unelevated>
              <q-btn dense outline label="+" @click="tolerance=parseInt(tolerance)+100" color="primary" style="height:40px;width:100%" size="md" :disabled="lat==='' || lat == null"/>
              <q-btn dense outline label="-" @click="(tolerance-100)>0?tolerance=tolerance-100:false" color="primary" style="height:40px;width:100%" size="md" :disabled="lat==='' || lat == null"/>
            </q-btn-group>
          </div>
        </div>
      </div>
      <div class="col-2 q-pl-md">
        <q-input v-model="lat" label="LAT" type="number" filled dense clearable/>
      </div>
      <div class="col-2 q-pl-md">
        <q-input v-model="lng" label="LNG" type="number" filled dense clearable/>
      </div>
      <div class="col-4 q-pl-md text-right">
        <q-btn dense outline label="Suche" @click="getCoordinates" color="primary" style="height:40px" class="q-px-md"/>
      </div>
    </div>

    <g-map-map :center="center" :zoom="zoom" :map-type-id="mapType" class="addressMap"
               @zoom_changed="zoomChange" @center_changed="centerChange" :options="{fullscreenControl:false, streetViewControl: false}">

      <g-map-marker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true"/>

      <g-map-circle v-if="markers.length>0" :radius="getTolerance()" :center="center" :options="{fillColor: '#FFD700', strokeOpacity:0}"/>
    </g-map-map>

  </div>
</template>
<script>
import axios from 'axios'
import {StaticData} from "src/classes/StaticData";

export default {
  props: [
    'formProperty'
  ],
  components: {},
  data() {
    return {
      value: null,
      street: "",
      city: "",
      plz: "",
      tolerance: 300,
      center: {lat: 48.30639, lng: 14.28611},
      zoom: 7,
      lat: 0,
      lng: 0,
      markers: [],
      mapType: "roadmap",
      addresses: []
    }
  },

  watch: {
    lat: "updateValue",
    lng: "updateValue",
    street: "updateValue",
    city: "updateValue",
    plz: "updateValue",
    tolerance: "updateValue"
  },

  methods: {
    getTolerance() {
      return parseInt(this.tolerance)
    },

    centerChange() {
    },

    zoomChange() {
    },

    getCoordinates() {
      const address = `${this.street}, ${this.city}, ${this.plz}`

      var geocoder = new window.google.maps.Geocoder();
      this.markers = []

      geocoder.geocode({address: address}, (results, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          var latitude = results[0].geometry.location.lat();
          var longitude = results[0].geometry.location.lng();
          console.log(`Latitude: ${latitude} | Longitude: ${longitude}`)

          let addressMarker = {
            poiCenter: latitude,
            poiSymcode: "",
            poiLegend: "",
            poiInfo: "",
            poiShowInfo: false,
            poiClicked: false,
            position: {lat: latitude, lng: longitude}
          }

          this.zoom = 15
          this.center = {lat: latitude, lng: longitude}
          this.markers.push(addressMarker)
          this.lat = latitude
          this.lng = longitude
          this.updateValue()

          console.log("geocode: ", this.value)

        } else {
          console.error('Geocode was not successful for the following reason: ' + status);
        }
      });
    },

    updateValue() {
      this.value = (this.lat != null ? this.lat : "") + ";" +
        (this.lng != null ? this.lng : "") + ";" +
        (this.tolerance != null ? this.tolerance : "") + ";" +
        (this.street != null ? this.street : "") + ";" +
        (this.city != null ? this.city : "") + ";" +
        (this.plz != null ? this.plz : "")

      this.formProperty.value = this.value
    },

    onChange(value) {
    },

    onRefreshComp(data) {
      if (this.formProperty.nativename === data.nativename) {
        if (this.formProperty.renderOnFrontend && (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
          this.value = data.value
        } else {
        }
      }
    },

    getValue() {
      let result = this.formProperty.value ? this.formProperty.value : this.formProperty.propertyInstanceValue

      if (result && result.startsWith("address://")) {
        result = result.replace("address://", "")
        let token = result.split(";")
        console.log("token:", token)
        this.lat = token[0]
        this.lng = token[1]
        this.tolerance = token[2] == null ? 300 : token[2]
        this.street = token[3]
        this.city = token[4]
        this.plz = token[5]

        console.log("ADRESS:", result)
        // console.log("ADRESS 2:", this.lat, this.lng, this.street)
      }
      return result
    }
  },

  beforeUnmount() {
    this.eventBus.off('onRefreshComp', this.onRefreshComp)
  },

  async mounted() {
    this.eventBus.on('onRefreshComp', this.onRefreshComp)

    let sParent = "cont_" + this.formProperty.nativename
    this.parentElement = document.getElementById(sParent)
    this.value = this.getValue()
    this.formProperty.value = this.value

    await this.$gmapApiPromiseLazy();
    this.getCoordinates()
    /*
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.google.com/maps/api/js?key=' + encodeURIComponent(PP_CONST.APP_THEME[PP_CONST.APP_ACTIVE].GMAP_API)
        console.log("append script:", script)
    */
    //document.head.appendChild(script);
  }
}
</script>

<style lang="sass">
.fldAddressGmapMeshup
  height: 500px

.addressMap
  height: 300px
</style>
